import { t } from "i18next";
import Apiauth from "../api/Apiauth";
import { errorCode, showToast } from "../utils";

/**
 * จัดการ Error จาก API และแจ้งเตือนผ่าน errorCode utility
 */
export const handleCheckError = (error, path, setLoader) => {
  // 1. ปิด Loading ก่อนเสมอหากมีการส่ง function มาให้
  if (typeof setLoader === "function") {
    setLoader(false);
  }

  // 2. ตรวจสอบลำดับความสำคัญของ Error
  // ลำดับ: Response Status > Error Code (Network) > Default
  const status = error?.response?.status;
  const code = error?.code;

  if (status) {
    errorCode(status, path);
  } else if (code) {
    errorCode(code, path);
  } else {
    // กรณี error อื่นๆ ที่ไม่ใช่จาก network/api
    console.error(`ERROR at ${path}:`, error.message || error);
  }
};

/**
 * ฟังก์ชันกลางสำหรับเรียก API
 * @param {Function} apiCall - ฟังก์ชัน Promise ของ API
 * @param {Function} successCallback - ทำงานเมื่อสำเร็จ
 * @param {Function} errorCallback - ทำงานเมื่อล้มเหลว
 * @param {Function} setLoader - ฟังก์ชันสำหรับควบคุม Loading state
 */
export const fetchData = async (
  apiCall,
  successCallback,
  errorCallback,
  setLoader,
) => {
  try {
    // เริ่มต้น Loading
    if (typeof setLoader === "function") setLoader(true);

    const res = await apiCall();

    // ตรวจสอบเงื่อนไขสำเร็จ (ตรวจสอบ res.data ก่อนป้องกัน undefined error)
    if (res?.data?.success) {
      if (successCallback) successCallback(res.data);
    } else {
      // กรณี API ตอบกลับมาแต่ success เป็น false
      const errorMessage = res?.data?.message || "เกิดข้อผิดพลาดในการดึงข้อมูล";
      showToast("error", errorMessage);
      if (errorCallback) errorCallback(res.data);
    }
  } catch (error) {
    // ส่ง path ไปยัง handleCheckError เพื่อทำ Log
    handleCheckError(error, "App.fetchData", setLoader);

    if (errorCallback) errorCallback(error);
  } finally {
    // มั่นใจว่า Loading จะถูกปิดไม่ว่าจะสำเร็จหรือล้มเหลว
    if (typeof setLoader === "function") setLoader(false);
  }
};


/**
 * ฟังก์ชันกลางสำหรับเรียก API Search Customer Data 
 * @param {string} event - ฟังก์ชัน Promise ของ API
 * @returns {string | null} - ไม่มีการคืนค่า แต่จะจัดการผลลัพธ์ภายในฟังก์ชัน
 */
export const getSearchCustomerData = async (event) => {
  let res = await Apiauth.searchCustomerData(event);
  if (res?.data?.success) {
    let isSearch = Array.isArray(res?.data?.data) ? res?.data?.data : [];
    let x = isSearch.find((data) => data.account_no === event?.search || data?.customer_uuid === event?.search);

    if (!x) return alert(t("Customer data not found."));

    return await x ;
  } else {
    showToast(
      "error",
      t(res?.data?.message) ||
      t("Failed to fetch customer data."),
    );
    return null;
  }
};
